import $ from "jquery";
import { useEffect } from "react";

export const useTabs = () => {
  useEffect(() => {
    const selector = `
      .td_tabs .td_tab_links a,
      .td_notice_tabs .td_tab_links a,
      .td_message_tabs .td_tab_links a
    `;

    const handleClick = function (
      this: HTMLAnchorElement,
      e: JQuery.ClickEvent,
    ) {
      e.preventDefault();

      const currentAttrValue = $(this).attr("href");

      if (!currentAttrValue) return;

      const wrapper = $(this).closest(
        ".td_tabs, .td_notice_tabs, .td_message_tabs",
      );

      const targetTab = wrapper
        .children(".td_tab_body")
        .find(currentAttrValue);

      // hide all
      wrapper.find(".td_tab").removeClass("active").hide();

      // show selected
      targetTab.show().addClass("active");

      // active nav item
      $(this)
        .closest("li")
        .addClass("active")
        .siblings()
        .removeClass("active");
    };

    $(document).on("click", selector, handleClick);

    return () => {
      $(document).off("click", selector, handleClick);
    };
  }, []);
};